import '../styles/index.css';

export interface NarrationBoxProps {
  text: string;
}

export function NarrationBox({ text }: NarrationBoxProps) {
  return (
    <div className="pawa-narration-container pawa-chat-item">
      <div className="pawa-narration-box">
        <span className="pawa-narration-text">{text}</span>
      </div>
    </div>
  );
}
